import { useEffect, useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { useLocation } from "react-router-dom";
import { NAV } from "@/constants/testIds";

const sectionLinks = [
  { label: "Início", hash: "#hero" },
  { label: "Soluções", hash: "#capabilities" },
  { label: "Experimente", hash: "#experimente" },
  { label: "Como funciona", hash: "#how" },
  { label: "Sistemas legados", hash: "#legacy" },
  { label: "Sobre", hash: "#solution" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const hrefFor = (hash) => (isHome ? hash : `/${hash}`);

  return (
    <header
      data-testid={NAV.root}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#050505]/80 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 h-[72px] flex items-center justify-between">
        <a
          href={isHome ? "#hero" : "/"}
          data-testid={NAV.logo}
          className="flex items-center gap-2 group"
        >
          <span className="h-2.5 w-2.5 bg-white rounded-full group-hover:scale-125 transition-transform" />
          <span className="font-display font-extrabold tracking-tight text-lg">
            RODE IA
          </span>
        </a>

        <nav className="hidden xl:flex items-center gap-5">
          {sectionLinks.map((l) => (
            <a
              key={l.hash}
              href={hrefFor(l.hash)}
              className="font-mono text-[12px] uppercase tracking-[0.18em] text-neutral-400 hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="/contato"
            className="font-mono text-[12px] uppercase tracking-[0.18em] text-neutral-400 hover:text-white transition-colors"
          >
            Contato
          </a>
        </nav>

        <a
          href="/contato"
          data-testid={NAV.ctaButton}
          className="hidden xl:inline-flex items-center gap-1.5 bg-white text-black font-semibold text-sm px-5 py-2.5 rounded-sm hover:bg-neutral-200 active:scale-95 transition-all"
        >
          Mapear meu processo
          <ArrowUpRight className="h-4 w-4" />
        </a>

        <button
          data-testid={NAV.mobileToggle}
          onClick={() => setOpen((v) => !v)}
          className="xl:hidden text-white p-2 -mr-2"
          aria-label="Menu"
          aria-expanded={open}
          aria-controls="mobile-site-menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div id="mobile-site-menu" className="xl:hidden bg-[#050505] border-t border-white/5 px-6 py-6 flex flex-col gap-4">
          {sectionLinks.map((l) => (
            <a
              key={l.hash}
              href={hrefFor(l.hash)}
              onClick={() => setOpen(false)}
              className="font-mono text-sm uppercase tracking-[0.18em] text-neutral-300 hover:text-white py-1"
            >
              {l.label}
            </a>
          ))}
          <a
            href="/contato"
            onClick={() => setOpen(false)}
            className="font-mono text-sm uppercase tracking-[0.18em] text-neutral-300 hover:text-white py-1"
          >
            Contato
          </a>
          <a
            href="/contato"
            onClick={() => setOpen(false)}
            className="mt-2 inline-flex items-center justify-center gap-1.5 bg-white text-black font-semibold text-sm px-5 py-3 rounded-sm"
          >
            Mapear meu processo <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      )}
    </header>
  );
};
